/**
 * Generate a random UUID.
 * @type {function}
 * @returns {string} - The UUID.
 */
export const generateUUID = () => {
    /** @type {string} */
    let uuid = '';
    /** @type {string} */
    const chars = '0123456789abcdef';

    for (let i = 0; i < 36; i++) {
        if (i === 8 || i === 13 || i === 18 || i === 23) {
            uuid += '-';
        } else if (i === 14) {
            uuid += '4'; // Version 4 UUID
        } else if (i === 19) {
            uuid += chars.charAt(Math.floor(Math.random() * 4) + 8); // 8, 9, a, or b
        } else {
            uuid += chars.charAt(Math.floor(Math.random() * 16));
        }
    }

    return uuid;
};

/**
 * Generate a random code.
 * @returns {string} - The code.
 */
export const generateCode = () => {
    return Math.random().toString(36).substring(2, 8);
};
